<span class="badge p-1 rounded-circle" [ngClass]="themeClass">
    <span class="visually-hidden">&nbsp;</span>
</span>
